import { create } from "zustand";

export const JOB_SUGGESTION_TABS = [
  "new-jobs",
  "last-jobs",
  "rejected-jobs",
  "accepted-jobs",
  "inactive-jobs",
] as const;

interface IJobSuggestionsStoreState {
  activeTab: string;
}

interface IJobSuggestionsStoreActions {
  setActiveTab: (tab: string) => void;
}

type TJobSuggestionsStore = IJobSuggestionsStoreState & IJobSuggestionsStoreActions;

const initialState: IJobSuggestionsStoreState = {
  activeTab: JOB_SUGGESTION_TABS[0],
};

export const useJobSuggestionsStore = create<TJobSuggestionsStore>((set) => ({
  ...initialState,
  setActiveTab: (tab: string) => set({ activeTab: tab }),
}));
